import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=153fa1c9"
import script from "./Specifications.vue?vue&type=script&lang=js"
export * from "./Specifications.vue?vue&type=script&lang=js"
import style0 from "./Specifications.vue?vue&type=style&index=0&id=153fa1c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports